<template lang="html">
    <div class="table-wrap flow-metrics-table">
        <p style="margin: 6px">The BC Streamflow Inventory (BCSI) has been updated using more recent hydrologic data to represent the normal period of 1981-2010. The standard discharge data used is published by the Water Survey of Canada (WSC). Results of these analyses are provided below. For more information, the full reports are available on Ecocat <a href="https://a100.gov.bc.ca/pub/acat/public/search.do">https://a100.gov.bc.ca/pub/acat/public/search.do</a> using the search parameter "Inventory of Streamflow".</p>

        <scrolling-table class="scroll-table" :data="scrollingTableData" />

    </div>
</template>

<script>
import streamflowData from '@/mixins/streamflowData';
import ScrollingTable from '@/components/ScrollingTable';

export default {
    name: 'flow-metrics-table',
    mixins: [streamflowData],
    components: {
        ScrollingTable,
    },
    computed: {
        headers() {
            const tableData = this.queryData.flow_metrics;
            if (!tableData || !tableData.headers) return [];
            return tableData.headers.map(i => ({
                text: i,
                value: i,
            }));
        },
        items() {
            const tableData = this.queryData.flow_metrics;
            if (!tableData || !tableData.items) return [];
            return tableData.items;
        },
        // @TODO: format table data like this in the API
        // ...and skip all these computed getters
        scrollingTableData() {
            const headers = this.headers.map((e) => {
                const text = e.text;
                return {
                    text,
                };
            });

            const items = this.items.map((e) => {
                const vals = e.map((cel) => {
                    const celObj = {
                        text: cel,
                    };
                    return celObj;
                });

                return vals;
            });

            const tableData = [
                headers,
                ...items,
            ];

            return tableData;
        },
    },
};
</script>

<style lang="scss">
.flow-metrics-table.table-wrap {
    overflow: auto;

    .scroll-table {
        height: calc(100vh - 220px - 100px);
    }

    div.footnotes > p {
        margin-top: 8px;
        padding-left: 16px;
        font-size: 12px;
        font-style: oblique;
        margin-bottom: 8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/charts/FlowMetricsTable.vue